<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import Qs from 'qs'
  let userType = {0:'模拟',1:'真实'}
  let sendType = {/*0:'自动发送',*/1:'定时发送'}
  let sendStatus = {0:'未发送',1:'成功',2:'失败'}
  import Url from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  import URL from "@/views/newmis36/util/url";
  let channel = {'mxt':"麦讯通",'xk':"先客国际"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }else if('下载' == clickName){
          //隐藏关键字段
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
          download.exportExcel(URL.smslog.export,param,'短信发送日志');
        }else if('导出' == clickName){
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
          download.exportExcel(URL.smslog.export,param,'短信发送日志');
        }
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '发送类别', field: 'sendType',type:2,optionList:sendType},
            { title: '推送类别', field: 'pushType'},
            { title: '短信内容', field: 'content'},
            {click:"查询",auth:"cfint:smslog:query"},
            {click:"下载",auth:"cfint:smslog:down"},
            {click:"导出",auth:"cfint:smslog:export"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.smslog.list, //请求路径和参数
          sequence: true,
          cols: [
            { title: '用户类别', field: 'userType',render: (data, full) => {
                return userType[data];
              }},
            { title: '客户账号', field: 'customer'},
            { title: '手机号', field: 'mobilePhone'},
            { title: '用户级别', field: 'userLevel'},
            { title: '发送类别', field: 'sendType',render: (data, full) => {
                return sendType[data];
              }},
            { title: '推送类别', field: 'pushType'},
         /*   { title: '条件id', field: 'ruleId'},
            { title: '条件name', field: 'ruleName'},*/
            { title: '发送状态', field: 'sendStatus',render: (data, full) => {
                return sendStatus[data];
              }},
            { title: '短信通道', field: 'channel',render: (data, full) => {
                return channel[data];
              }},
            { title: '短信内容', field: 'content'},
            { title: '发送时间', field: 'createTime',render: (data, full) => {
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: '备注', field: 'remark'},
          ]
        }
      }
    }
  }
</script>
